import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {LoginInfo} from "~/app/pages/login/login-info";
import {ActivatedRoute, ParamMap} from "@angular/router";
import {UserLoginResult} from "~/app/core/model/user-login-result";
import {InteractionType} from "~/app/core/model/interaction-type";
import {InteractionComponent} from "~/app/core/model/interaction-component";
import {RegistrationInfo} from "~/app/pages/login/registration-info";
import {BasePage} from "~/app/pages/base.page";
import {NetworkConnectionType} from "~/app/core/network.service";
import * as Log from "~/app/core/log";
import {validEmail, validName, validPhone} from "~/app/core/util/string-util";
import {CoreService} from "~/app/core/core.service";
import {UserProfileService} from "~/app/core/user-profile-service/user-profile.service";
import {Title} from "@angular/platform-browser";

@Component({
    selector: "signup",
    templateUrl: "./signup.page.html",
    styleUrls: ["./signup.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignupPage extends BasePage implements OnInit, AfterViewInit {
    offerId: number = null;
    loginInfo: LoginInfo = new LoginInfo();
    registrationInfo: RegistrationInfo = new RegistrationInfo();
    appleSignInSupported: boolean = false;

    showRegisterPassword: boolean = false;
    showSignupPassword: boolean = false;
    signUpRequestSent = false;
    activationCode = null;
    validated = false;

    tab = "register";
    referral_code: string = null;

    get isIOS() {
        return this.core && this.core.platform.is("ios");
    }

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly activatedRoute: ActivatedRoute,
        private readonly core: CoreService,
        private readonly title: Title,
    ) {
        super();
        this.title.setTitle('Sign Up');
    }

    ngOnInit(): void {
        this.appleSignInSupported = this.core.platform.is("ios");

        // Init your component properties here.
        // this.core.nav.handleBack(this.page, "/login", (args: any) => {
        //     return () => { this.core.nav.navPageSearching(this.api); };
        // });
        this.activatedRoute.queryParamMap.subscribe((value: ParamMap) => {
            if (value.has("offerId")) {
                this.offerId = Number(value.get("offerId"));
            }
            if (value.has("allowBack")) {
                this.allowBack = value.get("allowBack") === "true";
            }
        });
      this.referral_code = this.core.storage.loadCode();
          console.log(this.referral_code);
    }

  returningUser() {
    if (!this.waiting) {
      this.core.nav.navPageLogin();
    }
  }

  guestUser() {
    if (!this.waiting) {
      this.core.nav.navPageHome();
    }
  }

    ngAfterViewInit(): void {
    }

    onLoginWithFacebook() {
        if (!this.waiting) {
            if (this.core.net.connectionType === NetworkConnectionType.None) {
                this.handleNoData("login");
            } else {
                this.waitingSpinning = true;
                this.handleLogin(this.core.api.user_loginWithFacebook(), true, InteractionType.LoginFacebook);
            }
        }
    }

    onLoginWithGoogle() {
        if (!this.waiting) {
            if (this.core.net.connectionType === NetworkConnectionType.None) {
                this.handleNoData("login");
            } else {
                this.waitingSpinning = true;
                this.handleLogin(this.core.api.user_loginWithGoogle(), true, InteractionType.LoginGoogle);
            }
        }
    }

    onLoginWithApple() {
        if (!this.waiting) {
            if (this.core.net.connectionType === NetworkConnectionType.None) {
                this.handleNoData("login");
            } else {
                this.waitingSpinning = true;
                this.handleLogin(this.core.api.user_loginWithApple(), true, InteractionType.LoginApple);
            }
        }
    }

    onRegister() {
        if (!this.waiting) {
            if (this.registrationInfo.name.length < 3 || !validName(this.registrationInfo.name)) {
                this.core.toast.toastError({
                    header: "Registration Failure",
                    message: "Please enter a first and last name."
                });
            } else if (this.registrationInfo.email.length < 3 || !validEmail(this.registrationInfo.email)) {
                this.core.toast.toastError({
                    header: "Registration Failure",
                    message: "Please enter a valid email address."
                });
            } else if (this.registrationInfo.password.length < 8) {
              this.core.toast.toastError({
                header: "Registration Failure",
                message: "Please enter a password at least 8 characters long."
              });
            } else if (this.registrationInfo.password !== this.registrationInfo.conf_pass){
              this.core.toast.toastError({
                header: "Registration Failure",
                message: "Please make sure both passwords are the same."
              });
            } else if (this.registrationInfo.phone.length < 10 || !validPhone(this.registrationInfo.phone)){
              this.core.toast.toastError({
                header: "Registration Failure",
                message: "Please enter a valid phone number."
              });
            } else {
                if (this.core.net.connectionType === NetworkConnectionType.None) {
                    this.handleNoData("register");
                } else {
                    this.waiting = true;
                    this.cd.detectChanges();
                    const firstname = this.registrationInfo.name.substr(0, this.registrationInfo.name.indexOf(" ")).trim();
                    const lastname = this.registrationInfo.name.substr(this.registrationInfo.name.indexOf(" ") + 1).trim();
                    this.core.api.user_register(firstname, lastname,
                      this.registrationInfo.email, this.registrationInfo.password).then((result) => {
                        console.log("user_register:");
                        console.log(result);
                        if (result.success) {
                            this.waitingSpinning = false;
                            if (result.validated) {
                                this.core.api.offers_clearSearchResults();
                                this.core.nav.navPageSearching(this.core.api, this.offerId, false);
                            } else {
                              if (this.referral_code) {
                                this.validated = true;
                                this.core.api.user_validate(this.referral_code).then(() => {
                                    this.core.api.offers_clearSearchResults();
                                  this.core.nav.navPageHome();
                                });
                              }
                            }
                        } else {
                            this.waiting = false;
                            this.core.toast.toastError({
                                header: "Registration Failure",
                                message: "Unable to create a new account with the information you provided."
                            });
                            this.signUpRequestSent = false;
                        }
                        this.cd.detectChanges();
                    }, (reason) => {
                        if (reason === "UserAlreadyExists") {
                            this.waitingSpinning = false;
                            this.core.toast.toastError({
                                header: "Existing Account",
                                message: "The email you've provided is not available for account creation. Try to login using your password, or use Forgot Password if you cannot remember.",
                                onHide: () => {
                                    this.waiting = false;
                                    this.waitingSpinning = true;
                                    this.tab = "login";
                                    this.loginInfo.email = this.registrationInfo.email;
                                    this.cd.detectChanges();
                                }
                            });
                            this.signUpRequestSent = false;
                        } else {
                            this.waiting = false;
                            this.core.toast.toastError({
                                header: "Trouble",
                                message: "We're unable to create the account with the credentials you've provided."
                            });
                            this.signUpRequestSent = false;
                        }
                        this.cd.detectChanges();
                    });
                    this.signUpRequestSent = true;
                }
            }
        }
    }

  onActivate() {
    if (!this.validated) {
      if (this.registrationInfo.name.length < 3 || !validName(this.registrationInfo.name)) {
        this.core.toast.toastError({
          header: "Validation Failure",
          message: "Please enter the code found in the validation email sent to " + this.registrationInfo.email + ". You may need to check your span/junk folder."
        });
      } else {
        if (this.core.net.connectionType === NetworkConnectionType.None) {
          this.handleNoData("register");
        } else {
          this.waiting = true;
          this.cd.detectChanges();
          this.core.api.user_validate(this.activationCode).then((result) => {
            console.log("user_validate:");
            console.log(result);
            if (result.success) {
              this.waitingSpinning = false;
              this.validated = true;
              this.core.api.offers_clearSearchResults();
              this.core.nav.navPageHome();
              this.signUpRequestSent = false;
            } else {
              this.waiting = false;
              this.core.toast.toastError({
                header: "Validation Failure",
                message: "Unable to validate the account with the code you provided. Please check the email you received and try again."
              });
            }
            this.cd.detectChanges();
          }, (reason) => {
              this.waiting = false;
              this.core.toast.toastError({
                header: "Trouble",
                message: "We're unable to validate the account with the code you've provided."
              });
              this.signUpRequestSent = false;
            this.cd.detectChanges();
          });
          this.signUpRequestSent = true;
        }
      }
    }
  }

  onToggleRegisterPasswordSecure() {
        this.showRegisterPassword = !this.showRegisterPassword;
        this.cd.detectChanges();
    }

    onToggleSignupPasswordSecure() {
        this.showSignupPassword = !this.showSignupPassword;
        this.cd.detectChanges();
    }

    tapPrivacyPolicy(): void {
        if (!this.waiting) {
            this.core.nav.navPagePrivacyPolicy();
        }
    }

    tapTermsOfUse(): void {
        if (!this.waiting) {
            this.core.nav.navPageTermsOfUse();
        }
    }

    private handleLogin(loginResult: Promise<UserLoginResult>, social: boolean, loginType: InteractionType.LoginEmail|InteractionType.LoginFacebook|InteractionType.LoginGoogle|InteractionType.LoginApple) {
        if (!this.waiting) {
            this.waiting = true;
            this.waitingSpinning = true;
            this.cd.detectChanges();
            loginResult.then((result) => {
                Log.debug(Log.Tag.LoginPage, "result: ");
                Log.debug(Log.Tag.LoginPage, result);
                if (result.success) {
                    this.waitingSpinning = false;
                    if (result.validated) {
                        this.waiting = true;
                        this.waitingSpinning = false;
                        this.core.api.interaction(InteractionType.Login, InteractionComponent.LoginPage);
                        this.core.api.interaction(loginType, InteractionComponent.LoginPage);
                        this.core.toast.toastSuccess({
                            header: "Login Success",
                            message: "Thank you. Now enjoy your FREE offers!",
                            onHide: () => {
                                this.core.api.offers_clearSearchResults();
                              this.core.nav.navPageHome();
                            }
                        });
                    } else {
                        this.core.nav.navPageValidate(this.offerId, false);
                    }
                } else {
                    this.waiting = false;
                    this.waitingSpinning = true;
                    if (social) {
                        if (loginType === InteractionType.LoginFacebook) this.core.api.interaction(InteractionType.LoginSocialFailFacebook, InteractionComponent.LoginPage);
                        else if (loginType === InteractionType.LoginGoogle) this.core.api.interaction(InteractionType.LoginSocialFailGoogle, InteractionComponent.LoginPage);
                        else if (loginType === InteractionType.LoginApple) this.core.api.interaction(InteractionType.LoginSocialFailApple, InteractionComponent.LoginPage);
                        else this.core.api.interaction(InteractionType.LoginSocialFail, InteractionComponent.LoginPage);
                        // if cancelled from social login, don't show an error
                    } else {
                        this.core.api.interaction(InteractionType.LoginFail, InteractionComponent.LoginPage);
                        this.core.toast.toastError({
                            header: "Unsuccessful Login",
                            message: "Email or password were incorrect. Please verify your account credentials and try again."
                        });
                    }
                }
                this.cd.detectChanges();
            }, (error) => {
                Log.debug(Log.Tag.LoginPage, "ERROR:");
                Log.debug(Log.Tag.LoginPage, error);
                this.waiting = false;
                this.waitingSpinning = true;
                if (error === "AuthError") {
                    this.waitingSpinning = false;
                    this.core.toast.toastError({
                        header: "Invalid Credentials",
                        message: "The email or password you've entered does not match a user in our system. Try again, or use Forgot Password if you cannot remember."
                    });
                } else {
                    this.waiting = false;
                    this.core.toast.toastError({
                        header: "Trouble",
                        message: "Something went wrong while attempting to log in. Check all your info, make sure you have network connectivity, and try again."
                    });
                }
                this.cd.detectChanges();
            });
        }
    }

    private handleNoData(type: "login" | "register") {
        if (type === "login") {
            this.core.toast.toastError({
                header: "No Data",
                message: "Sorry! We can't sign you in without data or wi-fi available.\n\nPlease enable data and try again."
            });
        } else if (type === "register") {
            this.core.toast.toastError({
                header: "No Data",
                message: "Sorry! We can't sign you up without data or wi-fi available.\n\nPlease enable data and try again."
            });
        }
    }
}
